import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import "./createVoucher.css";
import contractService from "../../services/contract/contractService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../Footer/Footer";
import familyService from "../../services/family/familyService";
const CreateContartctWithVoucher = () => {
  const history = useHistory();
  const [step, setStep]= useState(0)
  const [familyList, setFamilyList] = useState();
  const [currentStep, setCurrentStep] = useState(0);
 
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [contractDto, setContractDto] = useState({
  birthdate: "",
  cin: "",
  color: "",
  email: "",
  firstName: "",
  idbroker: "e7aef862-d697-4bc1-87d7-43df8c4378f0",
  iddistributor: "c95401a6-657c-4f54-bca7-708cc677b79c",
  idformula: "726ca852-efd4-430c-9173-93524e4708bf",
  idproduct: "93c3c4c6-b47c-4153-9d6c-fd5cb1df3b74",
  idtypePayment: "86a342eb-38b8-4f44-9ae6-715bf16c7aG6",
  imei: "",
  inclusion: 0,
  lastName: "",
  model: "",
  phone: "",
  purchase_date: "",
  voucher:""
});
  
  useEffect(() => {
    window.scrollTo(0, 0);
    familyService.getAllFamily().then((res) => {
      setFamilyList(res.data.sort((a, b) => a.displayOrder - b.displayOrder).filter((elem, i) => elem.displayOrder < 4 ));
    });
  }, []);



  // Validation par étape
  const validateStep = () => {
    let newErrors = {};
    if (currentStep === 1) {
      if (!contractDto.firstName) newErrors.firstName = "Le prénom est obligatoire";
      if (!contractDto.lastName) newErrors.lastName = "Le nom est obligatoire";
      if (!contractDto.birthdate) newErrors.birthdate = "La date de naissance est obligatoire";
      if (!contractDto.email) {
        newErrors.email = "L'email est obligatoire";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contractDto.email)) {
        newErrors.email = "Format d'email invalide";
      }
      if (!contractDto.phone) {
        newErrors.phone = "Le numéro de téléphone est obligatoire";
      } else if (!/^(\+216)?[2-9][0-9]{7}$/.test(contractDto.phone)) {
        newErrors.phone = "Numéro de téléphone tunisien invalide";
      }
      if (!contractDto.cin) newErrors.cin = "Le numéro de carte d'identité est obligatoire";
    }

    if (currentStep === 2) {
      if (!contractDto.imei){
        newErrors.imei = "Le numéro IMEI est obligatoire";
      } 
      // else if(!/^\d{15}$/.test(contractDto.imei)){
      //   newErrors.imei = "Numéro IMEI invalide. Veuillez entrer un IMEI valide à 15 chiffres.";
      // }
      if (!contractDto.model) newErrors.model = "Le modèle est obligatoire";
      if (!contractDto.color) newErrors.color = "La couleur est obligatoire";
      if (!contractDto.purchase_date) newErrors.purchase_date = "La date d'achat est obligatoire";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  // Étape suivante
  const nextStep = () => {
    if (validateStep()) {
      window.scrollTo(0, 0);
      setCurrentStep((prev) => prev + 1);
    }
  };
   const nextStepp = () => {
      setCurrentStep((prev) => prev + 1);
    
  };

  // Étape précédente
  const prevStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  // Soumission finale
  const handleSubmit = (e) => {
    let newErrors = {};
    e.preventDefault();
    if (validateStep()) {

      contractService.createContartctWithVoucher(contractDto).then((res)=>{
            if(res.status== 200){
             nextStepp()
            }

        }).catch((errors)=>{
          console.log(errors);
          
          if(errors){
              newErrors.voucher = "Code de bon d'achat invalide. Veuillez entrer un code valide.";

              setErrors(newErrors);
              return Object.keys(newErrors).length === 0;
            }
        })
    }
  };


   const handleChange = (e) => {
    setContractDto({ ...contractDto, [e.target.name]: e.target.value });
  };

  return (
    <div className="container-fluid">
      <Header/>
      <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              height:"64px",
              backgroundColor: "#F7FAFC"
            }}
          >
              <img
                  onClick={prevStep}
                  style={{ width: "80px" ,padding: "10px",cursor:"pointer"}}
                  src={`${process.env.PUBLIC_URL}/assets/images/arrow.png`}
              />
            <h2
              style={{
                fontFamily: "Inter,sans-serif",
                fontWeight: "bold",
                color: "#0D141C",
                fontSize: "24px",
                letterSpacing:"0px",
                lineHeight:"23px",
                marginBottom:"0px"

              }}
            >
              Activez votre assurance
            </h2>
      </div>
      {/* page 1 */}
      {currentStep === 1 ?
      <div 
      style={{    
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
        }}>
        <h3 
        style={{
          fontFamily: "Inter,sans-serif",
          fontWeight: "500",
          color: "#0D141C",
          fontSize: "16px",
          lineHeight:"24px",
          marginLeft:"10px",
          marginTop:"10px"
        }} 
        >Étape 1 sur 4</h3>
        <div className="progress-bar">
          <div className="progress-fill">
          </div>
        </div>
      </div>:<></>}
      {currentStep === 2 ?
      <div style={{    
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
        }}>
        <h3 
        style={{
          fontFamily: "Inter,sans-serif",
          fontWeight: "500",
          color: "#0D141C",
          fontSize: "16px",
          lineHeight:"24px",
          marginLeft:"10px",
          marginTop:"10px"
        }} 
        >Étape 2 sur 4</h3>
        <div className="progress-bar">
          <div className="progress-fill2">
          </div>
        </div>
      </div>:<></>}
      {currentStep === 3 ?
      <div style={{    
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
        }}>
        <h3 
        style={{
          fontFamily: "Inter,sans-serif",
          fontWeight: "500",
          color: "#0D141C",
          fontSize: "16px",
          lineHeight:"24px",
          marginLeft:"10px",
          marginTop:"10px"
        }} 
        >Étape 3 sur 4</h3>
        <div className="progress-bar">
          <div className="progress-fill3">
          </div>
        </div>
      </div >:<></>}
      {currentStep === 4 ?
      <>
      <div style={{    
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column"
        }}>
        <h3 
        style={{
          fontFamily: "Inter,sans-serif",
          fontWeight: "500",
          color: "#0D141C",
          fontSize: "16px",
          lineHeight:"24px",
          marginLeft:"10px",
          marginTop:"10px"
        }} 
        >Étape 4 sur 4</h3>
        <div className="progress-bar">
          <div className="progress-fill4">
          </div>
        </div>
      </div>
       <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: "30px",
              paddingLeft: "5px"
            }}
          >
            <h2
              style={{
                fontFamily: "Inter,sans-serif",
                fontWeight: "bold",
                color: "#0F141A",
                fontSize: "22px",
                lineHeight:"28px",
                padding: "15px"
              }}
            >
              Félicitations ! Votre assurance est activée. <br/> 
              <p style={{
                fontFamily: "Inter,sans-serif",
                fontWeight: "400",
                color: "#0F141A",
                fontSize: "16px",
                lineHeight:"24px",
                marginTop:"20px"
              }}>
              Votre demande d'activation a été traitée avec succès. Vous êtes maintenant protégé contre les dommages et le vol de votre smartphone. Vous pouvez consulter les détails de votre couverture dans votre espace client.
            </p>
            </h2>
            
          </div>
      </>
      :<></>}
      {currentStep === 0 ?<>
      <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "40px",
              marginLeft: "16px",
              backgroundColor: "#FFFFFF"
            }}
        >
            <h2
              style={{
                fontFamily: "Inter,sans-serif",
                fontWeight: "bold",
                color: "#0F1417",
                fontSize: "28px",
                letterSpacing:"0px",
                lineHeight:"35px",

              }}
            >
              Activez votre assurance smartphone Club Privilège
            </h2>
      </div>
      <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "16px",
              backgroundColor: "#FFFFFF",
              marginRight:"16px"
            }}
        >
           <p style={{
                fontFamily: "Inter,sans-serif",
                fontWeight: "400",
                color: "#0F1417",
                fontSize: "16px",
                letterSpacing:"0px",
                lineHeight:"24px",
                fontStyle:"normal"
            }}>
              Protégez votre mobile contre la casse accidentelle ! Votre abonnement Club Privilège inclut une couverture contre les dommages accidentels pour votre smartphone, protégeant contre la casse d'écran, l'oxydation, l'infiltration et les dysfonctionnements, avec une limite de garantie allant jusqu'à 800 DT.
            </p>
      </div>
      <div className="row col-md-12 d-flex-center">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "30px",
              paddingLeft: "20px"
            }}
          >
            <h2
              style={{
                fontFamily: "Inter,sans-serif",
                fontWeight: "bold",
                color: "#0F1417",
                fontSize: "20px",
              }}
            >
              Garanties clés
            </h2>
          </div>
          <div
            className="col-md-12"
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "0",
              padding: "0",
            }}
          >
            <div className="col-md-8 gr-container1">
              <div
                className="row col-md-12 margin0 d-flex-j"
                style={{ position: "relative" }}
              >
                <div className="row col-md-12" style={{ position: "relative" }}>
                  <div
                    className="col-md-4 d-flex-a"
                    style={{
                      padding: "5px",
                      position: "relative",
                      justifyContent: "flex-start"
                    }}
                  >
                      <img
                        style={{ width: "70px" ,padding: "10px",}}
                        src={`${process.env.PUBLIC_URL}/assets/images/calandrier.png`}
                      />
                      <h3 
                      style={{   
                        fontFamily: "Century Gothic",
                         fontSize: "16px",
                        fontWeight: 600,
                        color: "#0F1417",
                        margin:"0",
                        color: "#0F1417",
                        margin:"0"
                        
                        }}
                        >
                        Durée de la couverture 
                        <br /> 
                        <p 
                        style={{   
                        fontFamily: "Inter,sans-serif",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginTop:"5px",
                        color: "#4C3489"
                        }}> 1 an</p>
                      </h3>
                  </div>
                  <div
                    className="col-md-4 d-flex-a"
                    style={{
                      padding: "5px",
                      position: "relative",
                      justifyContent: "flex-start"
                    }}
                  >
                      <img
                        style={{ width: "70px" ,padding: "10px",}}
                        src={`${process.env.PUBLIC_URL}/assets/images/dollar.png`}
                      />
                      <h3 
                      style={{   
                        fontFamily: "Century Gothic",
                         fontSize: "16px",
                        fontWeight: 600,
                        color: "#0F1417",
                        margin:"0"
                        }}
                        >
                        Limite de garantie
                         <br /> 
                        <p 
                        style={{   
                        fontFamily: "Inter,sans-serif",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginTop:"5px",
                        color: "#4C3489"
                        }}> 800 DT</p>
                      </h3>
                  </div>
                  <div
                    className="col-md-4 d-flex-a"
                    style={{
                      padding: "5px",
                      position: "relative",
                      justifyContent: "flex-start"
                    }}
                  >
                      <img
                        style={{ width: "70px" ,padding: "10px",}}
                        src={`${process.env.PUBLIC_URL}/assets/images/valid.png`}
                      />
                      <h3 
                      style={{   
                        fontFamily: "Century Gothic",
                         fontSize: "16px",
                        fontWeight: 600,
                        color: "#0F1417",
                        margin:"0"
                        }}
                        >
                        Types de couverture
                         <br /> 
                        <p 
                        style={{   
                        fontFamily: "Inter,sans-serif",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginTop:"5px",
                        color: "#4C3489"
                        }}> Casse, oxydation, infiltration, dysfonctionnements</p>
                      </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
         
      </div>
      <div className="row col-md-12 d-flex-center">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "30px",
              paddingLeft: "20px"
            }}
          >
            <h2
              style={{
                fontFamily: "Inter, sans-serif",
                fontWeight: "bold",
                color: "#0F1417",
                fontSize: "20px",
              }}
            >
              Conditions essentielles
            </h2>
          </div>
          <div
            className="col-md-12"
            style={{
              display: "flex",
              justifyContent: "center",
              margin: "0",
              padding: "0",
            }}
          >
            <div className="col-md-10 gr-container1">
              <div
                className="row col-md-12 margin0 d-flex-j"
                style={{ position: "relative" }}
              >
                <div className="row col-md-12" style={{ position: "relative" }}>
                  <div
                    className="col-md-3 d-flex-a"
                    style={{
                      padding: "5px",
                      position: "relative",
                      justifyContent: "flex-start"
                    }}
                  >
                      <img
                        style={{ width: "70px" ,padding: "10px",}}
                        src={`${process.env.PUBLIC_URL}/assets/images/age.png`}
                      />
                      <h3 
                      style={{   
                        fontFamily: "Century Gothic",
                         fontSize: "16px",
                        fontWeight: 600,
                        color: "#0F1417",
                        margin:"0"
                        }}
                        >
                        Âge du smartphone
                         <br /> 
                        <p 
                        style={{   
                        fontFamily: "Inter,sans-serif",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginTop:"5px",
                        color: "#4C3489"
                        }}> Moins de 2 ans</p>
                      </h3>
                  </div>
                  <div
                    className="col-md-3 d-flex-a"
                    style={{
                      padding: "5px",
                      position: "relative",
                      justifyContent: "flex-start"
                    }}
                  >
                      <img
                        style={{ width: "70px" ,padding: "10px",}}
                        src={`${process.env.PUBLIC_URL}/assets/images/facture.png`}
                      />
                      <h3 
                      style={{   
                        fontFamily: "Century Gothic",
                         fontSize: "16px",
                        fontWeight: 600,
                        color: "#0F1417",
                        margin:"0"
                        }}
                        >
                        Facture d'achat
                         <br /> 
                        <p 
                        style={{   
                        fontFamily: "Inter,sans-serif",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginTop:"5px",
                        color: "#4C3489"
                        }}>Requis</p>
                      </h3>
                  </div>
                  <div
                    className="col-md-3 d-flex-a"
                    style={{
                      padding: "5px",
                      position: "relative",
                      justifyContent: "flex-start"
                    }}
                  >
                      <img
                        style={{ width: "70px" ,padding: "10px",}}
                        src={`${process.env.PUBLIC_URL}/assets/images/localisation.png`}
                      />
                      <h3 
                      style={{   
                        fontFamily: "Century Gothic",
                         fontSize: "16px",
                        fontWeight: 600,
                        color: "#0F1417",
                        margin:"0"
                        }}
                        >
                        Lieu d'achat
                         <br /> 
                        <p 
                        style={{   
                        fontFamily: "Inter,sans-serif",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginTop:"5px",
                        color: "#4C3489"
                        }}> Tunisie</p>
                      </h3>
                  </div>
                  <div
                    className="col-md-3 d-flex-a"
                    style={{
                      padding: "5px",
                      position: "relative",
                      justifyContent: "flex-start"
                    }}
                  >
                      <img
                        style={{ width: "70px" ,padding: "10px",}}
                        src={`${process.env.PUBLIC_URL}/assets/images/limilt time.png`}
                      />
                      <h3 
                      style={{   
                        fontFamily: "Century Gothic",
                         fontSize: "16px",
                        fontWeight: 600,
                        color: "#0F1417",
                        margin:"0"
                        }}
                        >
                        Limite de réclamation
                         <br /> 
                        <p 
                        style={{   
                        fontFamily: "Inter,sans-serif",
                        fontSize: "14px",
                        fontWeight: 400,
                        marginTop:"5px",
                        color: "#4C3489"
                        }}> Une réclamation par abonnement</p>
                      </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
       </>:<></>
       }
      {<div className="row col-md-12 d-flex-j" style={{ marginBottom: "20px" }}>
        <div className="col-md-9">
          {currentStep === 1 && (<>
          <div 
          className="col-md-12 d-flex-j flex-d-c marginTop20">
          <div
            className="row col-md-12 marginTop20 "
            style={{ marginLeft: "0" }}
          >
            <div
              className="col-md-6 d-flex-j flex-d-c marginBot"
              style={{ paddingLeft: 0 }}
            >
              <label className="label-club">
                 Prénom
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="firstName"
                className="input-club"
                type="text"
                placeholder="Entrez votre prénom"
                value={contractDto.firstName}
                onChange={handleChange}
              />
              {errors.firstName && <p style={{ color: "red" }}>{errors.firstName}</p>}

            </div>
            <div
              className="col-md-6 d-flex-j flex-d-c"
              style={{ paddingLeft: 0 }}
            >
              <label className="label-club">
                Nom
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="lastName"
                className="input-club"
                type="text"
                placeholder="Entrez votre nom de famille"
                value={contractDto.lastName}
                onChange={handleChange}
              />
              {errors.lastName && <p style={{ color: "red" }}>{errors.lastName}</p>}
            </div>
          </div>
          </div>
          <div
            className="row col-md-12 marginTop20"
            style={{ marginLeft: "0" }}
          >
            <div
              className="col-md-6 d-flex-j flex-d-c marginBot"
              style={{ paddingLeft: 0 }}
            >
              <label className="label-club">
                 Date du naissance
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="birthdate"
                className="input-club"
                type="date"
                value={contractDto.birthdate}
                onChange={handleChange}
              />
              {errors.birthdate && <p style={{ color: "red" }}>{errors.birthdate}</p>}
            </div>
            <div
              className="col-md-6 d-flex-j flex-d-c"
              style={{ paddingLeft: 0 }}
            >
             <label className="label-club">
                  Adresse email<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="email"
                  className="input-club"
                  type="text"
                  placeholder="Entrer votre Email"
                  value={contractDto.email}
                  onChange={handleChange}
                />
                {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
            </div>
          </div>
          <div 
            className="row col-md-12 marginTop20" 
            style={{ marginLeft: "0" }}>
            <div
              className="col-md-6 d-flex-j flex-d-c marginBot"
              style={{ paddingLeft: 0 }}
            >
              <label className="label-club">
                Numéro de téléphone<span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="phone"
                className="input-club"
                type="number"
                placeholder="Entrer votre Numéro XX XXX XXX"
                value={contractDto.phone}
                onChange={handleChange}
              />
               {errors.phone && <p style={{ color: "red" }}>{errors.phone}</p>}
            </div>  
              <div
              className="col-md-6 d-flex-j flex-d-c"
              style={{ paddingLeft: 0 }}
            >
              <label className="label-club">
                Numéro carte d’identité<span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="cin"
                className="input-club"
                type="number"
                placeholder="Entrez votre Numéro carte d'identité"
                value={contractDto.cin}
                onChange={handleChange}
              />
              {errors.cin && <p style={{ color: "red" }}>{errors.cin}</p>}
              </div>
          </div>
          </>)}
          { currentStep === 2 && (<>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: "30px",
              paddingLeft: "5px"
            }}
          >
            <h2
              style={{
                fontFamily: "Inter,sans-serif",
                fontWeight: "bold",
                color: "#0F1417",
                fontSize: "22px",
                lineHeight:"28px"
              }}
            >
              Détails du smartphone
            </h2>
          </div>
          <div
            className="row col-md-12 marginTop20"
            style={{ marginLeft: "0" }}
          >
              <div
                className="col-md-6 d-flex-j flex-d-c marginBot"
                style={{ paddingLeft: 0 }}
              >
                <label className="label-club">
                  Numéro IMEI<span style={{ color: "red" }}>*</span>
                </label>
                <input
                  name="imei"
                  className="input-club"
                  type="text"
                  placeholder="Entrez l'IMEI"
                  value={contractDto.imei}
                  onChange={handleChange}
                />
                {errors.imei && <p style={{ color: "red" }}>{errors.imei}</p>}
              </div>
            <div
              className="col-md-6 d-flex-j flex-d-c"
              style={{ paddingLeft: 0 }}
            >
              <label className="label-club">
                Modèle<span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="model"
                className="input-club"
                type="text"
                placeholder="Entrez le modèle"
                value={contractDto.model}
                onChange={handleChange}
              />
              {errors.model && <p style={{ color: "red" }}>{errors.model}</p>}
            </div>
          </div>
          <div
            className="row col-md-12 marginTop20"
            style={{ marginLeft: "0" }}
          >
            <div
              className="col-md-6 d-flex-j flex-d-c marginBot"
              style={{ paddingLeft: 0 }}
            >
              <label className="label-club">
                 Couleur
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="color"
                className="input-club"
                type="text"
                placeholder="Entrez la couleur"
                value={contractDto.color}
                onChange={handleChange}
              />
              {errors.color && <p style={{ color: "red" }}>{errors.color}</p>}
            </div>
            <div
              className="col-md-6 d-flex-j flex-d-c"
              style={{ paddingLeft: 0 }}
            >
              <label className="label-club">
                Date d'achat
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="purchase_date"
                className="input-club"
                type="Date"
                placeholder="Date d'achat"
                value={contractDto.purchase_date}
                onChange={handleChange}
              />
               {errors.purchase_date && <p style={{ color: "red" }}>{errors.purchase_date}</p>}
            </div>
          </div>
          </>)}
          { currentStep === 3 && (<>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginTop: "30px",
              paddingLeft: "5px"
            }}
          >
            <h2
              style={{
                fontFamily: "Inter,sans-serif",
                fontWeight: "bold",
                color: "#0F1417",
                fontSize: "22px",
                lineHeight:"28px"
              }}
            >
              Code de bon d'achat
            </h2>
          </div>
            <div
            className="row col-md-12 marginTop20"
            style={{ marginLeft: "0" }}
          >
            <div
              className="col-md-6 d-flex-j flex-d-c marginBot"
              style={{ paddingLeft: 0 }}
            >
              <label className="label-club">
                 Code de bon d'achat
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                name="voucher"
                className="input-club"
                type="text"
                placeholder="Entrez le code de bon d'achat"
                value={contractDto.voucher}
                onChange={handleChange}
              />
              {errors.voucher && <p style={{ color: "red" }}>{errors.voucher}</p>}
            </div>
          </div>
          </>)}
        </div>
      </div>}

      {currentStep === 0 && <div className="row col-md-12 d-flex-center">
         <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
         }}>
            <div className="col-md-5 d-flex-a">
              <button
                onClick={nextStep}
                className="activation-btnn"
              >
                {"Activer mon assurance smartphone"}
              </button>
            </div>
          </div>
      </div>}
      {currentStep === 1 && <div className="row col-md-12 d-flex-center">
         <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
         }}>
            <div className="col-md-5 d-flex-a">
              <button
                onClick={nextStep}
                className="activation-btnn"
              >
                {"Activer mon assurance smartphone"}
              </button>
            </div>
          </div>
      </div>}
      {currentStep === 4 && <div className="row col-md-12 d-flex-center">
         <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
         }}>
            <div className="col-md-5 d-flex-a">
              <button
                onClick={()=>{
                  history.push({
                  pathname: "/",
                  });
                }}
                className="activation-btnn"
              >
                {"Retour à l'accueil"}
              </button>
            </div>
          </div>
      </div>}
      <div className="row col-md-12 d-flex-center">
         <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
         }}>
          { currentStep > 1 && currentStep < 4 && <div className="col-md-3 d-flex-a">
              <button
                onClick={prevStep}
                className="retour-btnn"
              >
                {"Retour"}
              </button>
            </div>}
            { currentStep == 2 && <div className="col-md-3 d-flex-a">
              <button
                onClick={nextStep}
                className="suivant-btnn"
              >
                {"Suivant"}
              </button>
            </div>}
            { currentStep == 3 && <div className="col-md-3 d-flex-a">
              <button
                onClick={handleSubmit}
                className="suivant-btnn"
              >
                {"Suivant"}
              </button>
            </div>}
          </div>
      </div>
      <Footer listFamily={familyList} />
    </div>
  );
};

export default CreateContartctWithVoucher;

const Header =()=>{
    return(
        <div>
             <div
      className="row col-12 nav-menu"
      style={{
        position: "relative",
        boxShadow: "0pt 10pt 22pt #0000000d",
        backgroundColor: "white",
        height: "95px",
        justifyContent: "space-around"
      }}
    >
      <div className="headweb-club" style={{justifyContent: "center" }}>
        <div
          className="col-md-12"
          style={{ display: "flex", justifyContent: "center" }}
        >
              <div
                className="col-md-12"
                style={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  marginLeft:"8%"
                }}
              >
                <a
                  href="https://clubprivileges.app/"
                  target="_blank"
                   style={{ display: "grid", position: "relative" }}
                >
                  <img
                    className="club_priv"
                    src={`${process.env.PUBLIC_URL}/assets/images/${
                      "logo club.svg"
                    }`}
                  />
                </a>
              </div>
        </div>
      </div>
       <div className="headweb-club" style={{justifyContent: "center" }}>
        <div
          className="col-md-12"
          style={{ display: "flex", justifyContent: "center" }}
        >
              <div
                className="col-md-12"
                style={{
                  display: "flex",
                  justifyContent: "right",
                  alignItems: "center",
                  marginRight: "8%"
                }}
              >
                <a
                  href="https://www.carte.com.tn/"
                  target="_blank"
                   style={{ display: "grid", position: "relative" }}
                >
                  <img
                    className="garantieXcarte"
                    src={`${process.env.PUBLIC_URL}/assets/images/${
                      "garanty x catre.png"
                    }`}
                  />
                </a>
              </div>
        </div>
      </div>
    </div>
        </div>
    )
};